import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCandleChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M6.75 4a.75.75 0 0 0-1.5 0v1.75H4.3c-.58 0-1.05.47-1.05 1.05v9.4c0 .58.47 1.05 1.05 1.05h.95V19a.75.75 0 0 0 1.5 0v-1.75h.75c.58 0 1.05-.47 1.05-1.05V6.8c0-.58-.47-1.05-1.05-1.05h-.75V4Zm.3 3.25v8.5h-2.3v-8.5h2.3ZM13.75 7a.75.75 0 0 0-1.5 0v1.75h-.95c-.58 0-1.05.47-1.05 1.05v9.4c0 .58.47 1.05 1.05 1.05h.95V22a.75.75 0 0 0 1.5 0v-1.75h.75c.58 0 1.05-.47 1.05-1.05V9.8c0-.58-.47-1.05-1.05-1.05h-.75V7Zm.3 3.25v8.5h-2.3v-8.5h2.3Z"
    />
    <path
      fill="#F7A600"
      d="M20.46 6.54a.65.65 0 0 0-.92 0l-2 2a.65.65 0 1 0 .92.92l.89-.89v5.097a.65.65 0 0 0 1.3 0V8.569l.89.89a.65.65 0 1 0 .92-.919l-2-2ZM17.246 1l.052.312a2.373 2.373 0 0 0 1.875 1.936 2.373 2.373 0 0 0-1.875 1.936l-.052.312-.05-.298a2.396 2.396 0 0 0-1.877-1.95 2.373 2.373 0 0 0 1.875-1.936L17.246 1Z"
    />
  </svg>
);
export default SvgTwoColorCandleChart;
